/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddIpAddressInput = {
    clientMutationId?: string | null;
    ipAddresses: string;
    username: string;
};
export type HomeContentAddIpAddressesMutationVariables = {
    input: infoAddIpAddressInput;
};
export type HomeContentAddIpAddressesMutationResponse = {
    readonly infoAddIpAddress: {
        readonly clientMutationId: string | null;
    } | null;
};
export type HomeContentAddIpAddressesMutation = {
    readonly response: HomeContentAddIpAddressesMutationResponse;
    readonly variables: HomeContentAddIpAddressesMutationVariables;
};



/*
mutation HomeContentAddIpAddressesMutation(
  $input: infoAddIpAddressInput!
) {
  infoAddIpAddress(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddIpAddressPayload",
    "kind": "LinkedField",
    "name": "infoAddIpAddress",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeContentAddIpAddressesMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeContentAddIpAddressesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bdcf900207eb433c8262450836d3a72c",
    "id": null,
    "metadata": {},
    "name": "HomeContentAddIpAddressesMutation",
    "operationKind": "mutation",
    "text": "mutation HomeContentAddIpAddressesMutation(\n  $input: infoAddIpAddressInput!\n) {\n  infoAddIpAddress(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b11bb1692be923a61bef942f52121a94';
export default node;
